import { Box, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";
import { QuestionCard } from "../mobilePreview.style";

type Props = {
  currentQuestion: any;
};

const NumberFieldPreview = ({ currentQuestion }: Props) => {
  const { properties } = currentQuestion;
  const [error, setError] = useState<string>("");
  const [value, setValue] = useState<any>();

  const validator = (value: string) => {
    const valueAsNumber = parseFloat(value);

    if (!properties?.allowDecimal && value.toString().includes(".")) {
      setError("Value must not be a decimal");
    } else if (
      typeof properties?.min === "number" &&
      typeof properties?.max === "number" &&
      (valueAsNumber < properties.min || valueAsNumber > properties.max)
    ) {
      setError(
        `Value must be between ${properties?.min} and ${properties?.max}`
      );
    } else if (
      typeof properties?.min === "number" &&
      valueAsNumber < properties.min
    ) {
      setError(`Value must be greater than ${properties?.min}`);
    } else if (
      typeof properties?.max === "number" &&
      valueAsNumber > properties.max
    ) {
      setError(`Value must be less than ${properties?.max}`);
    } else {
      setError("");
    }
  };

  const handleChange = (value: string) => {
    const num = parseFloat(value);
    validator(value);
    if (isNaN(num)) {
      setValue("");
    } else setValue(num);
  };

  return (
    <Box sx={{ ...QuestionCard, p: 2 }}>
      <TextField
        name="textValue"
        fullWidth
        value={typeof value === "number" ? value : ""}
        onChange={(e) => handleChange(e.target.value)}
        placeholder="Enter Value"
        type="number"
        InputProps={{
          inputProps: {
            min: properties?.min,
            max: properties?.max,
          },
          endAdornment: properties?.measurementUnit ? (
            <InputAdornment position="end">
              {properties.measurementUnit}
            </InputAdornment>
          ) : null,
        }}
        error={!!error}
        helperText={error}
      />
    </Box>
  );
};
export default NumberFieldPreview;
